import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AmenityItem from '../../AmenityItem/AmenityItem'

const SelectLocation = ({
  onBack = () => {},
  onNext = () => {},
  handleSelectLocation = () => {},
  title,
  canGoNext,
  selectedLocation,
  availablePlaces = [],
  style,
}) => {
  const { t } = useTranslation(['reservations', 'common'])
  return (
    <div>
      <div className="reservations-modal-content reservations-add-time-block-modal" style={style}>
        <span className="title">{title}</span>
        <div className="selectAmenityView">
          <div className="amenities">
            {availablePlaces.length ? (
              availablePlaces.map((place) => (
                <AmenityItem
                  key={place.id}
                  amenity={place}
                  isSelected={selectedLocation && place.id === selectedLocation.id}
                  onClick={handleSelectLocation}
                />
              ))
            ) : (
              <div>{t('reservations:reservationsAddTimeBlockModal.noPlacesAvailable')}</div>
            )}
          </div>
        </div>
      </div>
      <div className="reservations-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('reservations:shared.next')}
        </button>
      </div>
    </div>
  )
}

SelectLocation.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  handleSelectLocation: PropTypes.func,
  title: PropTypes.string,
  canGoNext: PropTypes.bool,
  selectedAmenity: PropTypes.object,
  selectedLocation: PropTypes.object,
  availablePlaces: PropTypes.array,
  style: PropTypes.object,
}

export default SelectLocation
